<template>
	<big-spinner class="spinner" />
</template>

<script setup lang="ts">
import BigSpinner from '@/assets/BigSpinner.svg'
</script>

<style lang="scss">
.spinner {
	animation: spin 1s linear infinite;
}

@keyframes spin {
	0% {
		transform: rotate(0deg);
	}
	100% {
		transform: rotate(360deg);
	}
}
</style>